/**
 * URLs of the style JSON served by MapboxStyleJsonsController. Kept free of
 * Mapbox imports so helpers that only need a URL can be tested in isolation.
 */

/**
 * The on-screen style for a slug. `slots=1` asks for the basemap import
 * inlined with Mapbox Standard's bottom / middle / top slots declared
 * (MapboxStyleSlots), which is what lets LayerRegistry keep a hike's lines and
 * markers under the place names (`belowLabels`). Web only — the apps request
 * the plain style. Print sheets keep the plain URL as well, so the preview and
 * the PDF renderer agree (HiikerMapStyle#printMapUrl).
 */
export function styleJsonUrl(slug: string): string {
  const localURL = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  const userId = window.user?.firebase_user_id || '';
  return `${localURL}/mapbox_style_jsons/${slug}.json?userId=${userId}&slots=1`;
}

/**
 * The same style URL without `slots=1`. For a URL that identifies a render
 * rather than loads a map — a flyover video is keyed on its style URL, so a
 * new param would re-render every existing video.
 */
export function withoutSlots(url: string): string {
  const [base, query = ''] = url.split('?');
  const kept = query.split('&').filter((p) => p && !p.toLowerCase().startsWith('slots='));
  return kept.length ? `${base}?${kept.join('&')}` : base;
}
